import { render, staticRenderFns } from "./BatchNotificationResidentForm.vue?vue&type=template&id=1683930b"
import script from "./BatchNotificationResidentForm.vue?vue&type=script&lang=js"
export * from "./BatchNotificationResidentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports